var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgImg = function SvgImg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 292,
    height: 165,
    viewBox: "0 0 292 165",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M19.3686 127.266H53.9376C50.238 123.86 47.8789 118.703 47.8789 112.93V108.689C47.8789 96.4002 38.9591 86.4381 27.9557 86.4381C16.6768 86.4381 7.53256 76.2257 7.53256 63.6287C7.53256 51.0317 16.6758 40.8192 27.9557 40.8192H31.302C42.3054 40.8192 51.2252 30.8572 51.2252 18.5687C51.2252 8.31289 58.6687 0 67.8503 0H197.75C207.969 0 216.254 9.25232 216.254 20.6664C216.254 28.4687 212.382 35.2605 206.667 38.7777H229.485C239.001 38.7777 246.715 46.7515 246.715 56.5874C246.715 68.3751 255.96 77.93 267.363 77.93H270.831C282.523 77.931 292 87.7265 292 99.8099C292 111.893 282.523 121.689 270.833 121.689C259.429 121.689 250.184 131.245 250.184 143.031V147.101C250.184 156.936 242.47 164.91 232.954 164.91H152.775C152.17 164.968 151.558 165 150.937 165H19.3705C8.96655 165 0.532928 156.553 0.532928 146.133C0.531952 135.713 8.96555 127.266 19.3686 127.266Z",
    fill: "url(#paint0_linear)",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M101 117.642L146.702 144L192.404 117.642L146.702 91.2845L101 117.642Z",
    fill: "#031FEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M101 110.578L146.702 136.936L192.404 110.578L146.702 84.2207L101 110.578Z",
    fill: "#031FEF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101 100.073L146.702 126.431L192.404 100.073L146.702 73.7155L101 100.073Z",
    fill: "#E4EAF8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.335 93.9973L138.563 91.8731C138.586 91.8335 138.601 91.7898 138.607 91.7445C138.613 91.6992 138.61 91.6532 138.598 91.609C138.586 91.5649 138.566 91.5235 138.538 91.4873C138.51 91.451 138.475 91.4206 138.436 91.3978L134.597 89.1875V74.6774L147.198 67.4224L159.8 74.6774V89.1875L156.101 91.3168C156.062 91.3396 156.027 91.37 155.999 91.4062C155.971 91.4424 155.951 91.4838 155.939 91.528C155.927 91.5721 155.924 91.6182 155.93 91.6635C155.936 91.7088 155.951 91.7525 155.974 91.7921L157.202 93.9161C157.248 93.9958 157.324 94.054 157.413 94.0778C157.502 94.1017 157.597 94.0892 157.677 94.0433L162.581 91.2125C162.687 91.1516 162.774 91.064 162.835 90.9585C162.896 90.853 162.928 90.7333 162.928 90.6114V73.2534C162.928 73.1315 162.896 73.0118 162.835 72.9062C162.774 72.8007 162.687 72.7131 162.581 72.6522L147.546 63.9739C147.44 63.9128 147.32 63.8807 147.198 63.8807C147.076 63.8807 146.956 63.9128 146.85 63.9739L131.815 72.6522C131.71 72.7131 131.622 72.8007 131.561 72.9062C131.5 73.0118 131.468 73.1315 131.468 73.2534V90.6114C131.468 90.7332 131.5 90.853 131.561 90.9585C131.622 91.064 131.71 91.1516 131.815 91.2125L136.86 94.1245C136.94 94.1705 137.035 94.1829 137.124 94.1591C137.213 94.1352 137.289 94.0771 137.335 93.9973Z",
    fill: "#031FEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.497 91.9953C148.688 91.9953 148.844 91.8389 148.844 91.6477V79.0346H152.064C152.355 79.0346 152.516 78.7001 152.338 78.4742L147.471 72.314C147.332 72.1358 147.063 72.1358 146.924 72.314L142.058 78.4699C141.88 78.6958 142.041 79.0303 142.332 79.0303H145.542V91.6477C145.542 91.8389 145.699 91.9953 145.89 91.9953H148.497ZM148.414 99.9908C148.507 99.9908 148.595 99.9541 148.66 99.8889C148.725 99.8238 148.762 99.7353 148.762 99.6431V95.4716C148.762 95.3794 148.725 95.291 148.66 95.2258C148.595 95.1606 148.507 95.124 148.414 95.124H145.981C145.889 95.124 145.8 95.1606 145.735 95.2258C145.67 95.291 145.633 95.3794 145.633 95.4716V99.6431C145.633 99.7353 145.67 99.8238 145.735 99.8889C145.8 99.9541 145.889 99.9908 145.981 99.9908H148.414Z",
    fill: "#031FEF"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M146.702 126.431V73.7155L101 47.3577V100.073L146.702 126.431Z",
    fill: "url(#paint1_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M146.878 126.431V73.7155L192.404 47.3577V100.073L146.878 126.431Z",
    fill: "url(#paint2_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M101 47.3578L146.702 73.7155L192.404 47.3578L146.702 21L101 47.3578Z",
    fill: "url(#paint3_radial)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 20.006,
    y1: 150,
    x2: 237.154,
    y2: 81.8767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#031FEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0CFACA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 101,
    y1: 86.8943,
    x2: 146.702,
    y2: 86.8943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#031FEF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#6D7EF6",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#BFC6FB",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F0F1FE",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 9057.68,
    y1: 6967.06,
    x2: 1217.52,
    y2: 14111.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#031FEF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#6D7EF6",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#BFC6FB",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F0F1FE",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.702 47.3578) scale(37.3165 37.2758)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.229167,
    stopColor: "#F0F1FE",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#BFC6FB",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#6D7EF6",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#031FEF",
    stopOpacity: 0.2
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgImg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/img.9161ed48.svg";
export { ForwardRef as ReactComponent };